export const getLogger = logger => {
    if (logger) {
        return logger;
    }
    return (name, attributes) => {
        // eslint-disable-next-line no-console
        console.log('CueMessageBroker event', name, attributes);
    };
};
//# sourceMappingURL=logger.js.map